var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('card-wrapper',[_c('matrix-upload-form',{attrs:{"action-text":_vm.$t('page.integration.form.actionText'),"action":_vm.integrate}})],1),_c('card-wrapper',[_c('control-tabs')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }